import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { BREAKPOINTS } from '@/styles/themes/default';

import { Container } from '../core/Grid';
import { ParagraphContainer, Heading } from './Common';

const ImageContainer = styled.picture`
  img {
    height: auto;
    object-fit: cover;
    width: 100%;
  }
`;

const GridContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'message'
    'image';
  grid-row-gap: 40px;
  margin-top: -120px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${BREAKPOINTS.Tablet.max}px) {
    max-width: 512px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  ${Heading} {
    margin-bottom: 32px;

    @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
      margin-bottom: 56px;
    }
  }

  ${ImageContainer} {
    grid-area: image;
  }

  ${ParagraphContainer} {
    grid-area: message;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    grid-template-columns: repeat(12, 1fr);
    grid-template-areas: none;
    grid-row-gap: 0;
    margin-top: -140px;

    ${ImageContainer} {
      grid-column: 1 / 7;
    }

    ${ParagraphContainer} {
      display: flex;
      flex-direction: column;
      justify-content: center;
      grid-column: 7 / -1;
    }
  }
`;

export const PostEventEngagement = () => {
  const { t } = useTranslation();

  return (
    <GridContainer>
      <ParagraphContainer>
        <Heading>{t('landing.postEventEngagement.title')}</Heading>
        <p>{t('landing.postEventEngagement.description')}</p>
        <p>{t('landing.postEventEngagement.digitalLibrary')}</p>
      </ParagraphContainer>
      <ImageContainer>
        <img src="/images/landing/digital-library.png" alt="digital library" />
      </ImageContainer>
    </GridContainer>
  );
};
